// ========= plugin import ====== //
import {useState, useEffect, useRef} from 'react'
import Swal from 'sweetalert2';
import axios from 'axios';
import { toast } from 'react-toastify';
// ======== component import ======== //
import SideDrawer from '../../../../../../../../component/common/SideDrawer';
import OthersSetupAdd from './component/OthersSetupAdd';
import OthersSetupUpdateDrawer from './component/OthersSetupUpdateDrawer';
import OthersSetupList from './component/OthersSetupList';
const InformationItem = (props) => {
    const {
        formData, 
        formValidateError
    } = props;
    const api_base_url = process.env.REACT_APP_API_URL;
    const loginUserType = localStorage.getItem('type');

    // -------- define all state here ------ //
    const [othersFormFetupState, setOthersFormFetupState] = useState(false);
    const [ othersFormUpdateId , setOthersFormUpdateId] = useState(-1);
    const [ othersForm, setOthersForm ] = useState([]);
    const [othersSetupDrawerIsOpen, setOthersSetupDrawerIsOpen] = useState(false);
    const [ updateOthersData , setUpdateOthersData ] = useState([]);
    const [othersDataIsLast, setOthersDataIsLast] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [isupdateInfoOpen, setIsupdateInfoOpen] = useState('')

    const othersFormSaveHandler = async (othersFormData) => {
        if(Object.keys(othersFormData).length > 0){
            setOthersFormFetupState(true)
            let isOthersDuplicate = false;
            if(formData['step2'].others_form_setup.information_item !== ''){
                isOthersDuplicate = formData['step2'].others_form_setup.some(
                    (products) => products.information_item.trim() === othersFormData.information_item.trim()
                );
            }

            // ------- duplicate action name checking -------- //
            let isDupProductFeatureAssociationData = false
            let serviceSetupAction = false
            let informationAction = false

            const informationData = formData['step2'].others_form_setup
            if(informationData.length > 0){
                informationAction = informationData.some(
                    (data) => data.action_name.trim() === othersFormData.action_name.trim()
                );
            }

            const productFeatureAssData = formData['step3'].product_features_association_data
            if(productFeatureAssData.length > 0){
                isDupProductFeatureAssociationData = productFeatureAssData.some(
                    (data) => data.action_name.trim() === othersFormData.action_name.trim()
                );
            }

            const serviceData = formData['step4'].service_setup
            if(serviceData.length > 0){
                serviceSetupAction = serviceData.some(
                    (data) => data.action_name.trim() === othersFormData.action_name.trim()
                );
            }

            if(othersFormUpdateId < 0){
                // --- insert --- //
                if (isOthersDuplicate) {
                    await Swal.fire({
                        text: 'Duplicate information cannot be added !',
                        icon: 'error',
                        showCancelButton: true,
                        showConfirmButton : false,
                        cancelButtonText: 'OK',
                    });
                    setIsFormSubmitted(true)
                    return;
                }

                if(
                    isDupProductFeatureAssociationData || 
                    serviceSetupAction || 
                    informationAction
                ){
                    await Swal.fire({
                        text: 'Duplicate action cannot be added !',
                        icon: 'error',
                        showCancelButton: true,
                        showConfirmButton : false,
                        cancelButtonText: 'OK',
                    });
                    setIsFormSubmitted(true)
                    return;
                }

                props.onInputChange(
                    'step2',
                    'others_form_setup',
                    [
                        ...(Array.isArray(formData['step2'].others_form_setup) ? formData['step2'].others_form_setup : []),
                        othersFormData
                    ]
                );
                setOthersForm((prevList) => [...prevList, othersFormData]);
            }
            else{
                // ---- update ---- //
                const updateOthersState = [...formData['step2'].others_form_setup];

                if(updateOthersState[othersFormUpdateId].action_name !== othersFormData.action_name){
                    if(
                        isDupProductFeatureAssociationData || 
                        serviceSetupAction || 
                        informationAction
                    ){
                        await Swal.fire({
                            text: 'Duplicate action cannot be added !',
                            icon: 'error',
                            showCancelButton: true,
                            showConfirmButton : false,
                            cancelButtonText: 'OK',
                        });
                        setIsFormSubmitted(true)
                        return;
                    }
                }

                if(updateOthersState[othersFormUpdateId].information_item !== othersFormData.information_item){
                    if (isOthersDuplicate) {
                        await Swal.fire({
                            text: 'Duplicate product name cannot be added !',
                            icon: 'error',
                            showCancelButton: true,
                            showConfirmButton : false,
                            cancelButtonText: 'OK',
                        });
                        setIsFormSubmitted(true)
                        return;
                    }
                }
                if(othersFormData.select_response){
                    if(othersFormData.select_response?.value !== 'static_response'){
                        othersFormData.initial_response = '';
                        othersFormData.final_response = '';
                        othersFormData.fail_response = '';
                    }
                }
                if(othersFormData.folow_up_details !== null){
                    if(othersFormData.folow_up_details?.value === 'opt_in'){
                        othersFormData.closing_utterance = '';
                        othersFormData.feedback = '';
                    }
                    else if(othersFormData.folow_up_details?.value === 'closing_utterance'){
                        othersFormData.feedback = '';
                        othersFormData.affiram_or_deny = null;
                        othersFormData.select_action = null;
                    }
                    else if(othersFormData.folow_up_details?.value === 'feedback'){
                        othersFormData.closing_utterance = '';
                        othersFormData.affiram_or_deny = null;
                        othersFormData.select_action = null;
                    }
                }
                if( othersFormData.affiram_or_deny?.value === 'no'){
                    othersFormData.select_action = null;
                }
                updateOthersState[othersFormUpdateId] = othersFormData;
                setOthersForm(updateOthersState);
                props.onInputChange(
                    'step2',
                    'others_form_setup',
                    updateOthersState
                );
                setOthersSetupDrawerIsOpen(false)
            }
            setOthersFormUpdateId(-1)
        }
    }

    const othersUpdateOnClickHandler = (index) => {
        setUpdateOthersData([othersForm[index]])
        setOthersFormUpdateId(index)
        setOthersSetupDrawerIsOpen(true)
    }
    const othersDeleteOnClickHandler = (index) => {
        setOthersFormFetupState(true)
        const updateOthersList = [...othersForm];
        if(updateOthersList.length === 1){
            setOthersDataIsLast(true)
        }
        updateOthersList.splice(index, 1);
        setOthersForm(updateOthersList);
        props.onInputChange(
            'step2',
            'others_form_setup',
            updateOthersList
        );
    }
    const othersSetupListOnDropHandler = (rearrangeData) => {
        setOthersFormFetupState(true)
        props.onInputChange(
            'step2',
            'others_form_setup',
            rearrangeData
        );
        setOthersForm(rearrangeData);
    }
    const drawerOnCloseHandler = (drawerName) => {
        const drawerMap = {
            others_setup_update_drawer: () => {
                setOthersSetupDrawerIsOpen(false); 
                setOthersFormUpdateId(-1);
            },
        };
        if (drawerMap[drawerName]) {
            drawerMap[drawerName]();
        }
    }

    useEffect(() => {
        setOthersFormFetupState(false)
        setOthersForm(formData['step2'].others_form_setup)
    },[formData['step2']]);

    const informationFormRef = useRef();
    useEffect(() => {
        const saveOthersDetails = async () => {
            if (!othersFormFetupState) return;
            const saveOthersData = async () => {
                let othersData = [];
                if (othersForm.length > 0) {
                    const indexedFeatures = othersForm.map((others, index) => ({
                        ...others,
                        index,
                    }));
                    othersData = indexedFeatures
                }

                let apiToken = '';
                if(loginUserType === 'A'){
                    apiToken = localStorage.getItem('token')
                }
                else if(loginUserType === 'D'){
                    apiToken = localStorage.getItem('developertoken')
                }
                else if(loginUserType === 'SA') {
                    apiToken = localStorage.getItem('systemAdminToken')
                }
                let othersFormData = new FormData();
                othersFormData.append("action_type", 'others_form_setup');
                othersFormData.append("bot_id", formData.bot_id);
                othersFormData.append("step", "step2");
                othersFormData.append("data", JSON.stringify(othersData));
                othersFormData.append("sass_id", localStorage.getItem('sass_id'));
                othersFormData.append("user_type", localStorage.getItem('type'));
                othersFormData.append("user_name", loginUserType == 'SA' ? localStorage.getItem('system_username') : '');
                const apiHeaders = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "x-access-token": apiToken,
                    },
                };
                try {
                    await axios.post(`${api_base_url}api/save-bot-details`, othersFormData, apiHeaders)
                    .then(async (res) => {
                        if(res.data.status === 'success'){
                            othersFormData = new FormData();
                            setOthersFormFetupState(false)
                            toast.success(res.data.message);
                            informationFormRef.current?.resetForm();
                            setIsFormSubmitted(true)
                        }
                        else{
                            toast.error("There is an error");
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                } catch (error) {
                    console.error("Error during save:", error);
                }
            };
            await saveOthersData();
        };
        saveOthersDetails()
    },[othersForm])

    return (
        <>
            <div className='row '>
                <a className="fw-bold text-gray-800 mb-2 fs-3">
                    Information item
                </a>
                <div className='col-md-12 border border-dashed border-gray-400 rounded p-5 mb-5'>
                    <OthersSetupAdd
                        formValidateError = {formValidateError}
                        othersFormSave = {othersFormSaveHandler}
                        updateOthersData = {updateOthersData}
                        formData={formData}
                        isInfoOpenHandler={props.isInfoOpenHandler}
                        ref={informationFormRef}
                        isFormSubmitted={isFormSubmitted}
                        isRefresh={() => setIsFormSubmitted(false)}
                    />
                    <OthersSetupList
                        othersForm = {othersForm}
                        othersUpdateOnClick = {othersUpdateOnClickHandler}
                        othersDeleteOnClick = {othersDeleteOnClickHandler}
                        othersSetupListOnDrop={othersSetupListOnDropHandler}
                    />
                </div>
            </div>
            <SideDrawer
                title={'Update Data'}
                width={isupdateInfoOpen=== 'open' ? 900 : 600}
                open={othersSetupDrawerIsOpen}
                drawer_name={'others_setup_update_drawer'}
                placement={'right'}
                closable={false}
                drawerOnClose={drawerOnCloseHandler}
            >
                <OthersSetupUpdateDrawer
                    formValidateError = {formValidateError}
                    othersFormSave = {othersFormSaveHandler}
                    updateOthersData = {updateOthersData}
                    formData={formData}
                    ref={informationFormRef}
                    isFormSubmitted={isFormSubmitted}
                    isRefresh={() => setIsFormSubmitted(false)}
                    isUpdateInfo= {(data) => setIsupdateInfoOpen(data.isOpen)}
                    drawerIsOpen={othersSetupDrawerIsOpen}
                />
            </SideDrawer>
        </>
    )
}

export default InformationItem
